"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorService = void 0;
const request_1 = require("../core/request");
class EditorService {
    /**
     * 获取页面信息
     * @param doc 文档 uuid
     * @returns any
     * @throws ApiError
     */
    static async getDoc(doc) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/${doc}`,
        });
        return result.body;
    }
    /**
     * 获取页面公开信息
     * @param doc 文档 uuid
     * @returns any
     * @throws ApiError
     */
    static async getDocPublicData(doc) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/${doc}/publicData`,
        });
        return result.body;
    }
    /**
     * 获取块祖先ids
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getAncestorBlocks(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/blocks/ancestors`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取页面的反向链接
     * @param doc 文档 uuid
     * @returns any
     * @throws ApiError
     */
    static async getDocBacklinks(doc) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/${doc}/backlinks`,
        });
        return result.body;
    }
    /**
     * 获取文档导航
     * @param doc 文档 uuid
     * @returns any
     * @throws ApiError
     */
    static async getNavs(doc) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/${doc}/navs`,
        });
        return result.body;
    }
    /**
     * 重置文档权限
     * @param doc 文档 uuid
     * @returns any
     * @throws ApiError
     */
    static async resetPagePermission(doc) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/${doc}/resetPagePermission`,
        });
        return result.body;
    }
    /**
     * 获取文档访问记录
     * @param doc 文档 uuid
     * @returns any
     * @throws ApiError
     */
    static async getDocVisits(doc) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/${doc}/visits`,
        });
        return result.body;
    }
    /**
     * 添加文档访问历史
     * @param doc 文档 uuid
     * @returns any
     * @throws ApiError
     */
    static async addDocVisits(doc) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/${doc}/visits`,
        });
        return result.body;
    }
    /**
     * 获取文档动态
     * @param doc 文档 uuid
     * @param startingAfterId 从哪条记录之后开始查询，用以分页
     * @param pageSize 每页多少条记录, 默认20条
     * @returns any
     * @throws ApiError
     */
    static async getDocActivities(doc, startingAfterId, pageSize) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/${doc}/activities`,
            query: {
                'startingAfterId': startingAfterId,
                'pageSize': pageSize,
            },
        });
        return result.body;
    }
    /**
     * 随机获取一张背景图的ossName(java)
     * @returns any
     * @throws ApiError
     */
    static async getCoverImage() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/image/random`,
        });
        return result.body;
    }
    /**
     * 封面图列表(java)
     * @returns any
     * @throws ApiError
     */
    static async getCoverImageList() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/image/list`,
        });
        return result.body;
    }
    /**
     * 复制subNodes
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async copySubNodes(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/copySubNodes`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 复制模板
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async copyTemplate(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/copyTemplate`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询某个文档的历史版本列表
     * @param doc 文档 uuid
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any
     * @throws ApiError
     */
    static async getDocHistories(doc, page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/${doc}/histories`,
            query: {
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 获取历史文档详情信息
     * @param doc 文档 uuid
     * @param history 历史 uuid
     * @returns any
     * @throws ApiError
     */
    static async getDocHistoryDetail(doc, history) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/${doc}/histories/${history}`,
        });
        return result.body;
    }
    /**
     * 恢复页面历史版本
     * @param doc 文档 uuid
     * @param history 历史 uuid
     * @returns any
     * @throws ApiError
     */
    static async restoreDocHistory(doc, history) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/${doc}/histories/${history}/restore`,
        });
        return result.body;
    }
    /**
     * 离开页面 - 删除自己在页面的权限
     * @param doc 文档 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async leaveDoc(doc, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/${doc}/leave`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 批量获取文档预览块
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async docsPreviewBatch(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/preview/batch`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取付费文档预览块
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async docsSharePagePreview(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/sharePage/preview`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取文档信息
     * @param doc 文档 uuid
     * @returns any
     * @throws ApiError
     */
    static async getDocInfo(doc) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/${doc}/info`,
        });
        return result.body;
    }
    /**
     * 跨空间移动块
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async docsMoveToSpace(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/moveToSpace`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 模板搜索
     * @param keywords 关键词
     * @param spaceId 空间id
     * @param searchSource 搜索来源,不传默认模板中心
     * @returns any
     * @throws ApiError
     */
    static async searchTemplates(keywords, spaceId, searchSource) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/templates/search`,
            query: {
                'keywords': keywords,
                'spaceId': spaceId,
                'searchSource': searchSource,
            },
        });
        return result.body;
    }
    /**
     * 获取文档块信息
     * @param block 文档块(或表单视图或评论) uuid
     * @returns any
     * @throws ApiError
     */
    static async getBlock(block) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/blocks/${block}`,
        });
        return result.body;
    }
    /**
     * 批量获取文件和文件夹 oss 地址
     * 批量获取文件和文件夹 oss 地址, 并且返回 hash 值
     *
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async blocksOssFileBatch(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/blocks/oss/file/batch`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 复制文档块
     * @param block 文档块(或表单视图或评论) uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async copyBlock(block, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/blocks/${block}/copy`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * @deprecated
     * 批量操作块
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async transactionBlock(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/blocks/transactions`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 根据url,获取链接页面信息
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async linkInfo(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/blocks/linkInfo`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询所有文件
     * 查询所有文件
     * @param space 空间 uuid
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any 返回值 data 长度小于 pageSize 的后不再请求
     * @throws ApiError
     */
    static async filesBlock(space, page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/files`,
            query: {
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 搜索文件或文件夹
     * 搜索文件或文件夹
     * @param space 空间 uuid
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @param search 搜索关键字
     * @param fileType 文件类型（image、video、audio、text）
     * @param type 内容类型类型（page、file），现只支持传单个类型
     * @returns any 返回值 data 长度小于 pageSize 的后不再请求
     * @throws ApiError
     */
    static async searchBlock(space, page, perPage, search, fileType, type) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/search`,
            query: {
                'page': page,
                'perPage': perPage,
                'search': search,
                'fileType': fileType,
                'type': type,
            },
        });
        return result.body;
    }
    /**
     * 搜索新接口
     * 搜索(doc)
     * @param space spaceId
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @param search 搜索关键字
     * @param fileType 文件类型（image、video、audio、text）
     * @param type 内容类型类型，现只支持传单个类型（page、file、folder、collection）或不传，不传时搜索类型包括文件夹、页面、多维表页面和内嵌多维表
     * @param source 搜索来源，取值为：move、trash、quickFind、collectionSettingsSource、relationMenu，默认：move类型（页面引用同move），当取值为trash或quickFind时，搜索类型为：文件夹、页面、多维表页面和内嵌多维表和文件，取值为collectionSettingsSource，表示搜索多维表，relationMenu与parentId配合使用，表示搜索当前父的可用下级块
     * @param parentId relationMenu与parentId配合使用，表示搜索当前父的可用下级块
     * @returns any 返回值 data 长度小于 pageSize 的后不再请求
     * @throws ApiError
     */
    static async searchDocs(space, page, perPage, search, fileType, type, source, parentId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/search/docs`,
            query: {
                'space': space,
                'page': page,
                'perPage': perPage,
                'search': search,
                'fileType': fileType,
                'type': type,
                'source': source,
                'parentId': parentId,
            },
        });
        return result.body;
    }
    /**
     * 查询当前空间容量使用情况
     * 查询当前空间容量使用情况
     * @param space 空间 uuid
     * @returns any 当前空间容量使用情况
     * @throws ApiError
     */
    static async capacityBlock(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/capacity`,
        });
        return result.body;
    }
    /**
     * 通过视图分享 ID 获取表单视图数据
     * @param share 视图分享 uuid
     * @returns any
     * @throws ApiError
     */
    static async formViewGetBlock(share) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/shares/${share}/formView`,
        });
        return result.body;
    }
    /**
     * 添加表单视图单行数据
     * @param share 视图分享 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async formViewPostBlock(share, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/shares/${share}/formView`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 用户举报
     * @param block 文档块(或表单视图或评论) uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async shareComplain(block, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/shares/${block}/complain`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 用户举报(非登录态)
     * @param block 文档块(或表单视图或评论) uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async shareComplainUnSign(block, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/shares/${block}/complainUnsign`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 用户申诉，若type为comment，path的{block}为评论id
     * @param block 文档块(或表单视图或评论) uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async shareAppeal(block, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/shares/${block}/appeal`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 核查是否能举报和申诉
     * @param block 文档块(或表单视图或评论) uuid
     * @param type 检查的类型（complain、appeal）
     * @returns any
     * @throws ApiError
     */
    static async shareCheck(block, type) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/shares/${block}/check`,
            query: {
                'type': type,
            },
        });
        return result.body;
    }
    /**
     * 获取单个 collectionView
     * 获取单个 collectionView
     * @param view collectionView uuid
     * @returns any
     * @throws ApiError
     */
    static async getCollectionView(view) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/collectionViews/${view}`,
        });
        return result.body;
    }
    /**
     * 批量操作记录
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async transactionRecords(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/records/transactions`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 批量查询记录
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async queryRecords(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/records/query`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询空间内更新的 block（客户端离线技术需求使用）
     * @param space 空间 uuid
     * @param time 更新时间,毫秒时间戳
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @param type 块类型，逗号分割
     * @returns any
     * @throws ApiError
     */
    static async querySpaceUpdateBlocks(space, time, page, perPage, type) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/syncBlocks`,
            query: {
                'time': time,
                'page': page,
                'perPage': perPage,
                'type': type,
            },
        });
        return result.body;
    }
    /**
     * 查询空间内更新的 record（客户端离线技术需求使用）
     * @param space 空间 uuid
     * @param time 更新时间,毫秒时间戳
     * @param table 表名称
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any
     * @throws ApiError
     */
    static async querySpaceUpdateRecords(space, time, table, page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/syncRecords`,
            query: {
                'time': time,
                'table': table,
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 查询最近访问历史
     * @param space 空间 uuid
     * @param sinceTimestamp 查询从指定时间开始之后的记录
     * @returns any
     * @throws ApiError
     */
    static async querySpaceVisitsHistory(space, sinceTimestamp) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/visitsHistory`,
            query: {
                'sinceTimestamp': sinceTimestamp,
            },
        });
        return result.body;
    }
    /**
     * 添加最近访问历史
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async addSpaceVisitsHistory(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/${space}/visitsHistory`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询空间汇总
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async querySpaceCollection(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/${space}/collection`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询空间是否可以拷贝进内容
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async checkCapacityForCopy(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/checkCapacityForCopy`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 下载文件夹下的文件（去重后）
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async downloadFolder(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/download/folder`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 下载图片信息(返回数据流)
     * @param url 图片地址
     * @returns any
     * @throws ApiError
     */
    static async downloadImg(url) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/download/img`,
            query: {
                'url': url,
            },
        });
        return result.body;
    }
    /**
     * 查询最近上传的图片（icon或cover）
     * @param space 空间 uuid
     * @param imgType 图片类型（icon或cover）
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any
     * @throws ApiError
     */
    static async querySpaceRecentlyImages(space, imgType, page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/images/recently`,
            query: {
                'imgType': imgType,
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 清空最近上传记录（icon或cover）
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async clearSpaceRecentlyImages(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/${space}/images/recentlyClear`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 多维表 option 重命名
     * @param collection collection block id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async renameCollectionOption(collection, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/collection/${collection}/renameOption`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 导入文档接口
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async import(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/import`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 导入文档接口 - 剪藏生成临时导入文件
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createImportTempFile(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/import_temp_file`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取通知未读数
     * @param spaceId 空间id，不传返回用户所有空间的未读数
     * @returns any
     * @throws ApiError
     */
    static async getNotificationUnreadCount(spaceId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/notifications/unread`,
            query: {
                'spaceId': spaceId,
            },
        });
        return result.body;
    }
    /**
     * 设置消息已读
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async setNotificationRead(requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/notifications/read`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取通知列表
     * @param spaceId
     * @param channel
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any
     * @throws ApiError
     */
    static async getNotificationList(spaceId, channel, page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/notifications/list`,
            query: {
                'spaceId': spaceId,
                'channel': channel,
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 清理极光别名绑定设备
     * @returns any
     * @throws ApiError
     */
    static async clearJPushAlias() {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/notifications/clearJPushAlias`,
        });
        return result.body;
    }
    /**
     * 触发消息通知
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async triggerNotification(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/notifications/trigger`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 使用获取的块信息批量下载文件
     * 根据文件批量生成 zip 包，并返回下载地址
     *
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async filesDownloadOssZip(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/files/download/oss/zip`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 通过块 ID 批量下载文件
     * 根据文件批量生成 zip 包，并返回下载地址
     *
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async filesDownloadBlocksOssZip(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/files/download/blocks/oss/zip`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 批量生成文件的预览图
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async filesPreviewOssProcess(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/files/preview/oss/process`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 通过 URL 地址导出文件
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async browserExport(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/browser/export`,
            body: requestBody,
        });
        return result.body;
    }
}
exports.EditorService = EditorService;
